export enum DashboardTabValues {
  Todo = 'todo',
  MyFeed = 'my-feed',
  Training = 'training',
  Recent = 'recent',
}
